// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ko-6";
export var emphasizeQuantity = "_ko-3";
export var flatBottomCorners = "_ko-5";
export var productImage = "_ko-0";
export var quantityContainer = "_ko-2";
export var tooltip = "_ko-1";
export var wrapAndEllipsesOverflow = "_ko-4";